import Vue from 'vue'
import Router from 'vue-router'
import * as cookie from '@static/js/cookieUtil.js';
Vue.use(Router)

const auth = resolve => require(['@/components/auth'], resolve)//微信授权页面
const check = resolve => require(['@/components/check'], resolve)//检查用户状态页面
const reg = resolve => require(['@/components/reg'], resolve)//微信注册页面
const account = resolve => require(['@/components/account'], resolve)//切换用户页面
const scanLogin = resolve => require(['@/components/scan-login'], resolve)//微信扫码登录页面
const scanConfirm = resolve => require(['@/components/scan-confirm'], resolve)//微信扫码登录确认页面
const menu = resolve => require(['@/components/menu'], resolve)//微信公众号菜单链接

const err404 = resolve => require(['@/components/404'], resolve) //404页面
const timeOut = resolve => require(['@/components/time-out'], resolve) //请求超时页面
const errWxAuth = resolve => require(['@/components/error'], resolve) //微信授权提示用微信打开
const errBrowser = resolve => require(['@/components/err-browser'], resolve) //微信授权提示用微信打开

const iosFileDownload = resolve => require(['@/components/file-download-ios'], resolve) //ios文件下载中转页
// 子路由视图VUE组件
import student from '@/frame/student'
import teacher from '@/frame/teacher'

import studentRouter from './student.js'
import teacherRouter from './teacher.js'


const router = new Router({
    routes: [
    {
            path: '/student',
            component: student,
            children: studentRouter
        },
        {
            path: '/teacher',
            component: teacher,
            children: teacherRouter
        },
        // {
        //     path: '*',
        //     redirect: '/404'
        // },
        {
            path: '/404',
            meta: {
                isAuth: false,
            },
            component: err404
        },
        {
            path: '/timeout',
            component: timeOut
        },
        {
            path: '/menu/:type',
            component: menu,
            meta: {
                title: ''
            }
        },
        {
            path: '/scan/login',
            component: scanLogin,
            meta: {
                isAuth: false,
                title: '扫码登录'
            }
        },
        {
            path: '/scan/confirm/:token',
            component: scanConfirm,
            meta: {
                // isAuth : false,
                title: '扫码登录'
            }
        },
        {
            path: '/error/wx-auth',
            meta: {
                isAuth: false,
            },
            component: errWxAuth
        },
        {
            path: '/error/browser',
            meta: {
                isAuth: false,
            },
            component: errBrowser
        },
        {
            path: '/auth',
            meta: {
                isAuth: false,
            },
            component: auth
        },
        {
            path: '/check',
            component: check
        },
        {
            path: '/reg',
            meta: {
                isAuth: false,
                title: '扫码登录'
            },
            component: reg
        },
        {
            path: '/account',
            component: account
        },
        {
        	name:'file-download-ios',
            path:'/file-download-ios',
            component: iosFileDownload,
            meta: {
            	isAuth: false,
                title : '文件下载'
            }
        },
    ],
    scrollBehavior (to, from, savedPosition) {
		if(to.meta.savedPosition){
			$(to.meta.selector).scrollTop(to.meta.savedPosition);
		}
	}
});

var debug = false;
var checked = false;

router.beforeEach((to,from,next) =>{
  var path = to.fullPath;
  if (path) {
    if (window._hmt) { // 存到百度统计
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
	//若是文件下载中转页则不做登录判断
	if(to.name && to.name.indexOf('file-download-ios') > -1){
		return next();
	}
    if(path.indexOf('&') > -1){//处理相册刷新的问题
        return next(path.split('&')[0]);
    }
	if(debug){ // 测试服id 2156, 开发服id 77
		cookie.setCookie("SC_COOKIE_USER_ID", 23885);//20383 //491 //20386//27839 //355 //27839教师  //27068 雅玲教师 //28673 shangmin
    }

    var isWeixinBrowser = /micromessenger/.test(navigator.userAgent.toLowerCase());
	var isChrome = navigator.userAgent.indexOf("Chrome") > -1 || navigator.userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
	var isEdge = navigator.userAgent.indexOf("Edge") > -1 ;

	if(!isWeixinBrowser && !debug){//判断是否在微信
		var userId = cookie.getCookie("SC_COOKIE_USER_ID");
		if(!userId){//已登录过，不走微信授权
			if(path.indexOf('error') > -1 || path.indexOf('scan/login') > -1 || path.indexOf('scan/confirm') > -1 ){
				return next();
			}
			return next('/scan/login');
		}
    }

    if(!isWeixinBrowser){//判断是否在微信
		if((!isChrome || isEdge) ){
			if(path.indexOf('error') > -1){
				return next();
			}
			return next('/error/browser');
		}
		var userId = cookie.getCookie("SC_COOKIE_USER_ID");
		if(!userId){//已登录过，不走微信授权
			if(path.indexOf('error') > -1 || path.indexOf('scan/login') > -1 || path.indexOf('scan/confirm') > -1 ){
				return next();
			}
			return next('/scan/login');
        }
    }

    var allowBack = true //    给个默认值true
    if (to.meta.allowBack !== undefined) {
        allowBack = to.meta.allowBack
    }
    if (!allowBack) {
        history.pushState(null, null, location.href)
    }

    if (to.matched.length === 0) { //如果未匹配到路由
        if (!from.fullPath || from.fullPath == '/') {
            return next('/auth');
        }  
        return next(from.fullPath);  //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    }

    if (to.meta.title) {
        document.title = to.meta.title
    }


    if (path.indexOf('/sign/pc/') > -1) {//授课端签到
        var sign = {
            schoolId: to.params.schoolId,
            coursewareId: to.params.coursewareId
        }
        cookie.setCookie("SC_SIGN", JSON.stringify(sign), 1);
    }
    if (path.indexOf('/sign/app/') > -1) {//小组端签到
        var sign = {
            schoolId: to.params.schoolId,
            mac: to.params.mac,
            coursewareId: to.params.coursewareId
        }
        cookie.setCookie("SC_SIGN", JSON.stringify(sign), 1);
    }
    if (path.indexOf('/join/class/') > -1) {
        var join = {
            schoolId: to.params.schoolId,
            classId: to.params.classId
        }
        cookie.setCookie("SC_JOIN", JSON.stringify(join), 1);
    }
    if (path.indexOf('/join/group/') > -1) {
        var join = {
            schoolId: to.params.schoolId,
            mac: to.params.mac,
            coursewareId: to.params.coursewareId
        }
        cookie.setCookie("SC_JOIN", JSON.stringify(join), 1);
    }
    //以下为未登录

    var isAuth = to.meta.isAuth;
    if (isAuth != false && (path.indexOf('student') > -1 || path.indexOf('teacher') > -1 || path.indexOf('scan') > -1)) {
        var urlPath = encodeURIComponent(path);
        cookie.setCookieEXP("SC_COOKIE_URL", urlPath, 300);
    }

    if (isAuth == false) { //isAuth = false 页面无需校验
        return next();
    } else { //页面需要校验
        var userId = cookie.getCookie("SC_COOKIE_USER_ID");
        if (userId) { //已登录过，不走微信授权
            if (checked) { //已刷新过
                return next(); //直接过
            } else {
                checked = true; //标记已刷新
                return next({ path: '/check', replace: true }); //去同步信息页面
            }
        }
        var SC_WX_USER_COOKIE = cookie.getCookie("SC_WX_USER_COOKIE");

        if (SC_WX_USER_COOKIE) {
            return next('/reg'); //去注册选择页面
        }
        return next('/auth'); //去授权页面
    }
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//   router.replace(targetPath);
//   }
// });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js